import React, { Component } from "react";

//Import CSS

//Import internal components
import AppContext from "../../appContext";
import FormularioEmpresa from "../../components/forms/FormularioEmpresa";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import PhoneUtils from "../../shared/utils/PhoneUtils";
import CepUtils from "../../shared/utils/CepUtils";
import EmailUtils from "../../shared/utils/EmailUtils";

class CadastroEmpresa extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payload: {
        cnpj: CnpjUtils.cleanCnpj(this.props.cnpj),
        tipoParticipante: "",
        razaoSocial: "",
        nomeFantasia: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        estado: "",
        cidade: "",
        emailEmpresa: "",
        dddCelular: "",
        celular: "",
        dddTelefone: "",
        telefone: "",
        email: "",
      },
      showErrors: false,
      errors: {},
    };
    this.formRef = React.createRef();
    this.formularioEmpresaRef = React.createRef();

    CadastroEmpresa.contextType = AppContext;
  }

  componentDidMount() {
    // Sincronizar estado inicial com props
    if (this.props.dados) {
      this.setState({
        payload: {
          ...this.state.payload,
          ...this.props.dados,
        },
      });
    }

    // Focar no primeiro campo quando o componente é montado
    setTimeout(() => {
      if (this.formularioEmpresaRef.current && this.formularioEmpresaRef.current.focusFirstField) {
        this.formularioEmpresaRef.current.focusFirstField();
      }
    }, 100);
  }

  focusFirstField = () => {
    if (this.formularioEmpresaRef.current && this.formularioEmpresaRef.current.focusFirstField) {
      this.formularioEmpresaRef.current.focusFirstField();
    }
  }

  handleChange = (name, value) => {
    const updatedPayload = {
      ...this.state.payload,
      [name]: value,
    };

    const updatedErrors = { ...this.state.errors };
    if (updatedErrors[name]) {
      delete updatedErrors[name];
    }

    this.setState({ payload: updatedPayload, errors: updatedErrors }, () => {
      if (this.props.onUpdateEmpresa) {
        this.props.onUpdateEmpresa(updatedPayload);
      }
    });
  };

  handleUpdateMultiple = (camposAtualizados) => {
    const updatedPayload = {
      ...this.state.payload,
      ...camposAtualizados,
    };

    const updatedErrors = { ...this.state.errors };
    Object.keys(camposAtualizados).forEach(campo => {
      if (updatedErrors[campo]) {
        delete updatedErrors[campo];
      }
    });

    this.setState({ payload: updatedPayload, errors: updatedErrors }, () => {
      if (this.props.onUpdateEmpresa) {
        this.props.onUpdateEmpresa(updatedPayload);
      }
    });
  };

  validateForm = () => {
    const form = this.formRef.current;
    if (!form) return false;

    const inputs = form.querySelectorAll("input, select");
    let formValid = true;
    const newErrors = {};

    inputs.forEach(input => {
      const name = input.name;
      const value = input.value || "";

      // Para campos com máscara (telefone, celular, cep, cpf, rg, datanasc), verificar apenas dígitos
      const maskedFields = [
        "telefone",
        "celular",
        "cep",
        "cpf",
        "rg",
        "datanasc",
        "dddCelular",
        "dddTelefone"
      ];
      const isMaskedField = maskedFields.includes(name);

      let isEmpty;
      if (isMaskedField) {
        // Para campos com máscara, verificar se tem dígitos suficientes
        const cleanedValue = PhoneUtils.cleanPhone(value);
        if (name === "cep") {
          isEmpty = cleanedValue.length !== 8;
        } else if (name === "dddCelular" || name === "dddTelefone") {
          isEmpty = cleanedValue.length !== 2;
        } else if (name === "telefone" || name === "celular") {
          isEmpty = cleanedValue.length < 8 || cleanedValue.length > 9;
        } else {
          // Para outros campos com máscara, verificar se está vazio ou só tem underscore
          isEmpty = !value.trim() || (value.includes("_") && cleanedValue.length === 0);
        }
      } else {
        if (name === "tipoParticipante") {
          isEmpty = !value.trim();
        } else {
          const trimmedValue = value.trim();
          isEmpty = !trimmedValue || (trimmedValue.length > 0 && trimmedValue.replace(/_/g, "").length === 0);
        }
      }

      input.classList.remove("has-error");

      // Validação de email
      if (name === "emailEmpresa" && !isEmpty) {
        if (!EmailUtils.validateEmail(value)) {
          input.classList.add("has-error");
          newErrors[name] = "Email inválido";
          formValid = false;
          return;
        }
      }

      // Validação de DDD (2 dígitos)
      if ((name === "dddCelular" || name === "dddTelefone") && value.trim()) {
        const dddLimpo = PhoneUtils.cleanPhone(value);
        if (dddLimpo.length !== 2) {
          input.classList.add("has-error");
          newErrors[name] = "DDD deve ter 2 dígitos";
          formValid = false;
          return;
        }
      }

      // Validação de telefone/celular (8-9 dígitos)
      if ((name === "telefone" || name === "celular") && value.trim()) {
        const telefoneLimpo = PhoneUtils.cleanPhone(value);
        if (telefoneLimpo.length < 8 || telefoneLimpo.length > 9) {
          input.classList.add("has-error");
          newErrors[name] = "Telefone deve ter 8 ou 9 dígitos";
          formValid = false;
          return;
        }
      }

      if (input.hasAttribute("required") && isEmpty) {
        input.classList.add("has-error");
        newErrors[name] = "Campo obrigatório";
        formValid = false;
      }
    });

    this.setState({ errors: newErrors, showErrors: true });

    if (!formValid) {
      const firstError = form.querySelector(".has-error");
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        firstError.focus();
      }
    }

    return formValid;
  };

  handleSubmit = e => {
    e.preventDefault();
    const formValid = this.validateForm();

    if (formValid) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.props.ChangeOption(2);
    }
  };

  render() {
    return (
      <div className="signup-right__next-account" id="firstForm">
        <form className="signup-right__next-account--form" autoComplete="off" ref={this.formRef} onSubmit={this.handleSubmit} noValidate>
          <FormularioEmpresa
            ref={this.formularioEmpresaRef}
            values={this.state.payload}
            errors={this.state.errors}
            readOnlyFields={["cnpj"]}
            onChange={this.handleChange}
            onUpdateMultiple={this.handleUpdateMultiple}
            showLabels={true}
          />
          <div className="text-center">
            <button className="signup-right__next-account--button is--blue" type="submit" disabled={this.state.disabled}>
              Próximo
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default CadastroEmpresa;
